
/*eslint-disable */

/*
* gives model a opacity
*/

AFRAME.registerComponent("model-opacity", {
    schema: { default: 1.0 },
    init: function() {
      this.el.addEventListener("model-loaded", this.update.bind(this));
    },
    update: function() {
      var mesh = this.el.getObject3D("mesh");
      var data = this.data;
      if (!mesh) {
        return;
      }
      mesh.traverse(function(node) {
        if (node.isMesh) {
          node.material.opacity = data;
          node.material.transparent = data < 1.0;
          node.material.needsUpdate = true;
        }
      });
    }
  });